module.exports = __webpack_public_path__ + "a7f44d2642f35e17ccc01ee196883475.svg";